<template>
  <div>
    <van-sticky>
      <div style="display: flex; justify-content: space-around; align-items: center; padding: 8px 0">
        <span style="color: deepskyblue; font-weight: 500">出库单据列表</span>
        <van-button v-if="!readOnly" style="color: deepskyblue; font-weight: 500; width: 100px" @click="selectGoods"
                    size="normal">
          选择商品
        </van-button>
      </div>
      <div style="border-top: solid 1px gray; height: 0"></div>
    </van-sticky>

    <div :style="{'height': listHeight + 'px'}" style="background-color: darkgray; overflow: scroll">
      <transition-group name="list-complete">
        <div style="background-color: white; padding: 8px 0" key="top">
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">单据编号</label>
            <span v-if="!!outbound.id" class="value">{{ outbound.code }}</span>
            <el-input v-else class="value" v-model="outbound.code" style="width: 150px"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">选择仓库</label>
            <span v-if="readOnly" class="value">{{
                outbound.warehouseId | valueName('Warehouse')
              }}-{{ outbound.warehousePosId | valueName('WarehousePos') }}
            </span>
            <wx-warehouse-select v-else class="value" v-model="outbound.warehouse"
                                 style="position: relative; top: -4px"></wx-warehouse-select>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">出库日期</label>
            <span v-if="readOnly" class="value">{{ outbound.outDate }}</span>
            <wx-date-select v-else class="value" v-model="outbound.outDate"
                            style="position: relative; top: -4px"></wx-date-select>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">经办人</label>
            <span v-if="readOnly" class="value">{{ outbound.operatorUserName }}</span>
            <remote-van-select v-else class="value" class-name="OutboundUser" v-model="outbound.operatorUserAccount"
                               :options="outboundUserOptions" style="position: relative; top: -4px">
            </remote-van-select>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">备注</label>
            <el-input class="value" v-model="outbound.remarks" style="width: 200px" :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">物流公司</label>
            <el-input class="value" v-model="outbound.logisticsCompany" style="width: 200px"
                      :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">物流单号</label>
            <el-input class="value" v-model="outbound.logisticsCode" style="width: 200px"
                      :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">运费金额</label>
            <el-input class="value" v-model="outbound.freight" style="width: 200px" :disabled="readOnly"></el-input>
          </div>
          <div style="display: flex; align-items: center; height: 34px; line-height: 34px">
            <label class="label">结算账户</label>
            <el-input class="value" v-model="outbound.settlementAccount" style="width: 200px"
                      :disabled="readOnly"></el-input>
          </div>
        </div>
        <div style="border-top: solid 1px gray; height: 0" key="line"></div>
        <div v-for="(item, index) of outbound.goodsList" :key="item.id"
             style="background-color: white; margin: 0 4px 8px 4px; padding: 6px; overflow: hidden;"
             class="list-complete-item">
          <div>
            <div style="height: 26px; line-height: 28px;" :style="{'margin-top': index > 0 ? '6px' : 0}">
              <label class="label">序号</label>
              <span class="value">
              <span style="width: 30px; display: inline-block">{{ index }}</span>
            </span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品编号</label>
              <span class="value">{{ item.code }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品名称</label>
              <span class="value">{{ item.name }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品类型</label>
              <span class="value">{{ item.typeCode | valueName('GOODS_TYPE') }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">生产日期</label>
              <span class="value">{{ item.productionDate }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">有效期</label>
              <span class="value">{{ item.expireDays + ' 天' }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">单位</label>
              <span class="value">{{ item.unit }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">数量</label>
              <span class="value">{{ item.num }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品单价</label>
              <span class="value">{{ item.price + ' 元' }}</span>
              <van-button v-if="!readOnly" plain hairline type="danger" style="float: right; margin: 0 10px 6px 0"
                          size="small"
                          @click="deleteGoods(item)">删除商品
              </van-button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <!--    <div style="border-top: solid 1px gray; height: 0"></div>-->
    <div style="display: flex; justify-content: center; background-color: white; padding: 20px">
      <template v-if="!readOnly">
        <van-button type="primary" style="margin-right: 20px; width: 150px" @click="applyOutbound">出 库</van-button>
        <van-button style="margin-right: 20px; width: 150px" @click="save">保 存</van-button>
        <van-button style="width: 150px" @click="cancel">取 消</van-button>
      </template>
      <el-button v-else @click="cancel">返 回</el-button>
    </div>

    <wx-select-out-goods v-model="selectGoodsPopup.show" :outbound="selectGoodsPopup.outbound"
                         @update="updateGoodsList" :cand-goods-list="goodsList"></wx-select-out-goods>
  </div>
</template>

<script>
import { Outbound } from '@/store/objdef/objectDef'
import { Button, Popup, Search, Sticky, Tag, Field, DatetimePicker, Toast } from 'vant'
import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import WxWarehouseSelect from '@/views/wx/product/WxWarehouseSelect'
import WxDateSelect from '@/views/wx/product/WxDateSelect'
import RemoteVanSelect from '@/components/selector/RemoteVanSelect'
import authority from '@/utils/authority'
import WxSelectOutGoods from '@/views/wx/product/WxSelectOutGoods'
import { findGoods } from '@/utils/request'

export default {
  name: 'WxOutboundGoods',
  mixins: [resizeCaptureMixin],
  components: {
    WxSelectOutGoods,
    RemoteVanSelect,
    WxDateSelect,
    WxWarehouseSelect,
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker
  },
  data () {
    return {
      outbound: new Outbound(),
      selectGoodsPopup: {
        show: false,
        outbound: new Outbound()
      },
      goodsList: null,
      oldOutbound: null
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'OutboundUser')
    this.outbound.operatorUserAccount = this.$store.state.user.userAccount
    this.$store.dispatch('outbound/all').then(list => {
      for (const outbound of list) {
        if (outbound.id.toString() === this.$route.query.outboundId) {
          this.outbound = outbound
          this.oldOutbound = this.$_.cloneDeep(this.outbound)
          break
        }
      }
    })
  },
  methods: {
    selectGoods () {
      if (!this.outbound.warehouse || !this.outbound.warehouse[1]) {
        Toast.fail('请选择仓库！')
        return
      }
      this.selectGoodsPopup.outbound = this.$_.cloneDeep(this.outbound)
      this.selectGoodsPopup.show = true
    },
    deleteGoods (goods) {
      this.$confirm(`确认删除商品【${goods.name}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (const index in this.outbound.goodsList) {
          const item = this.outbound.goodsList[index]
          if (item.id === goods.id) {
            this.outbound.goodsList.splice(index, 1)
          }
        }
      }).catch(() => {
      })
    },
    updateGoodsList (goodsList) {
      this.outbound.goodsList = goodsList
    },
    applyOutbound () {
      if (!this.check()) return
      if (this.outbound.goodsList.length === 0) {
        Toast.fail('请选择商品！')
        return
      }
      this.outbound.status = 2
      this.save()
    },
    save () {
      if (!this.check()) return
      if (typeof this.outbound.outDate === 'object') {
        this.outbound.outDate = this.outbound.outDate.format('yyyy-MM-dd')
      }
      const isAdd = !this.outbound.id
      this.$store.dispatch('outbound/' + (isAdd ? 'add' : 'updateOne'), this.$_.cloneDeep(this.outbound)).then(() => {
        this.$router.go(-1)
        this.$message.success((this.outbound.status === 0 ? '保存' : '出库') + '成功!')
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    check () {
      if (!this.outbound.warehouse || !this.outbound.warehouse[1]) {
        Toast.fail('请选择仓库！')
        return false
      }
      if (!this.outbound.outDate) {
        Toast.fail('请选择出库日期！')
        return false
      }
      return true
    }
  },
  computed: {
    readOnly () {
      return this.outbound.status !== 0 || !this.$hasPermission(authority.OUTBOUND)
    },
    listHeight () {
      return this.clientHeight - 110 - 20 - 20
    },
    outboundUserOptions () {
      const options = [{ value: this.$store.state.user.userAccount, text: this.$store.state.user.name }]
      for (const item of this.$store.state.data.OutboundUser || []) {
        options.push({ value: item.account, text: item.name })
      }
      return options
    }
  },
  watch: {
    'outbound.warehouse': {
      handler (warehouse) {
        this.outbound.goodsList = this.outbound.goodsList
          .filter(item => item.warehouseId === warehouse[0] && item.warehousePosId === warehouse[1])
        if (warehouse && warehouse[1]) {
          findGoods({ warehouseId: warehouse[0], warehousePosId: warehouse[1] }).then(resp => {
            this.goodsList = resp.data
            if (this.oldOutbound) {
              for (const goods of this.goodsList) {
                for (const oldGoods of this.oldOutbound.goodsList) {
                  if (goods.id === oldGoods.id && goods.inboundId === oldGoods.inboundId) {
                    goods.remain += oldGoods.num
                    break
                  }
                }
              }
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  display: inline-block;
  width: 100px;
  color: #646464;
  font-size: 14px;
  text-align: right;
  height: 28px;
  line-height: 28px;
}

.value {
  display: inline-block;
  color: black;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
  margin-left: 20px;
}

/deep/
.el-input--small .el-input__inner {
  height: 28px;
  line-height: 28px;
}
</style>
